// Drop into theme.liquid or a custom JS asset
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product__media-wrapper').forEach(wrapper => {
    const buttons  = wrapper.querySelector('.slider-buttons');
    const total    = parseInt(wrapper.querySelector('.slider-counter--total')?.textContent) || 0;
    if (!buttons || total < 2) return;

    // Build dot bar
    const dotBar = document.createElement('div');
    dotBar.className = 'slider-dots';
    dotBar.style.cssText = 'display:flex;gap:6px;align-items:center;position:absolute;left:50%;transform:translateX(-50%);';
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('span');
      dot.dataset.index = i;
      dot.style.cssText = `
        width:6px;height:6px;border-radius:50%;
        background:rgba(0,0,0,0.25);
        transition:background 0.2s,transform 0.2s;
        cursor:pointer;
      `;
      dotBar.appendChild(dot);
    }
    buttons.appendChild(dotBar);

    // Update active dot
    const currentEl = wrapper.querySelector('.slider-counter--current');
    const updateDots = () => {
      const current = parseInt(currentEl?.textContent || '1') - 1;
      dotBar.querySelectorAll('span').forEach((dot, i) => {
        dot.style.background = i === current ? 'rgba(0,0,0,0.85)' : 'rgba(0,0,0,0.25)';
        dot.style.transform  = i === current ? 'scale(1.3)' : 'scale(1)';
      });
    };

    // Dawn updates the counter text when slides change — observe it
    new MutationObserver(updateDots).observe(currentEl, { childList: true });
    updateDots(); // set initial state
  });
});